(function () {
  if (!location.pathname.includes("/products/viaim-opennote")) return;

  var flowClass = "viaim-opennote-flow";
  var hiddenClass = "viaim-hidden-selection";
  var data = {
    Black: {
      base: {
        free: ["48515272573174", 229.00, 229.00, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/opennote_awards.jpg?v=1770129054"],
        pro: ["51253318353142", 289.00, 308.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/opennote_-pro-black_f1635336-4002-4f53-8c07-e1d94ef4372d.png?v=1780984474"],
        ultra: ["51253318385910", 349.00, 388.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/opennote_-ultra-black_1ab3ddab-5bf1-4e44-a7e7-cb2c789f6b37.png?v=1780984592"]
      },
      noteKit: {
        free: ["50548666302710", 279.00, 318.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/opennote_notekit.jpg?v=1776935494"],
        pro: ["51497690300662", 339.00, 398.98, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/proopennotebundle-4.png?v=1781317957"],
        ultra: ["51497690333430", 409.00, 478.98, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/ultopennotebundle.png?v=1781318131"]
      }
    },
    White: {
      base: {
        free: ["50548666335478", 229.00, 229.00, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/OpenNote_39716f2c-5739-4e5e-8d1e-92695059aab8.jpg?v=1770129054"],
        pro: ["51253318418678", 289.00, 308.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/opennote_-pro-white_dd90055f-682b-496d-a34b-93392cbdb5b0.png?v=1780984474"],
        ultra: ["51253318451446", 349.00, 388.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/opennote_-ultra-white_9d6bd407-f03b-43f6-92f4-4c029e2130ac.png?v=1780984592"]
      },
      noteKit: {
        free: ["50548666368246", 279.00, 318.99, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/opennote_notekit_2_93f55c21-96e0-4d19-b29e-190280159d2c.jpg?v=1776935513"],
        pro: ["51497690366198", 339.00, 398.98, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/proopennotebundle-3.png?v=1781317957"],
        ultra: ["51497690398966", 409.00, 478.98, "https://cdn.shopify.com/s/files/1/0722/7647/6150/files/ultopennotebundle-2.png?v=1781318132"]
      }
    }
  };

  function normalizeVariantId(id) {
    return String(id || "").split("/").pop();
  }
  function liveProductVariants() {
    var node = document.querySelector("script[data-viaim-product-variants]");
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || "[]");
    } catch (error) {
      return [];
    }
  }
  function syncPricingFromShopify() {
    var live = liveProductVariants();
    if (!live.length) return;
    var byId = {};
    live.forEach(function (variant) {
      byId[normalizeVariantId(variant.id)] = variant;
    });
    for (var color in data) {
      for (var kit in data[color]) {
        for (var plan in data[color][kit]) {
          var item = data[color][kit][plan];
          var liveVariant = byId[normalizeVariantId(item[0])];
          if (!liveVariant) continue;
          if (liveVariant.price != null && liveVariant.price !== "") {
            item[1] = Number(liveVariant.price) / 100;
          }
          var compareAt = liveVariant.compare_at_price;
          item[2] = compareAt != null && compareAt !== "" ? Number(compareAt) / 100 : item[1];
          if (liveVariant.featured_image && liveVariant.featured_image.src) {
            item[3] = liveVariant.featured_image.src;
          }
          item[4] = liveVariant.available !== false;
          item[5] = liveVariant.featured_media && liveVariant.featured_media.id;
        }
      }
    }
  }
  syncPricingFromShopify();
  var legacy = {
    "50757276008694": ["Black", false, "pro"],
    "50757276041462": ["Black", false, "ultra"],
    "50757276074230": ["White", false, "pro"],
    "50757276106998": ["White", false, "ultra"]
  };
  var colors = ["Black", "White"];
  var selections = [
    "OpenNote",
    "OpenNote + NoteKit",
    "OpenNote + Annual Pro Plan",
    "OpenNote + Annual Ultra Plan",
    "OpenNote + NoteKit + Annual Pro Plan",
    "OpenNote + NoteKit + Annual Ultra Plan"
  ];
  var state = stateFromVariant(new URLSearchParams(location.search).get("variant")) || { color: "Black", noteKit: false, plan: null };
  var timer = 0;
  var disclosureOpen = { kit: false, plans: false };
  var lastGalleryVariant = null;

  function isCompactView() {
    return !!section().querySelector("[data-viaim-opennote-compact]");
  }

  var css = ".viaim-opennote-flow{margin:22px 0 18px;color:rgb(var(--color-foreground,29 29 31));font-family:inherit}.viaim-opennote-flow *{box-sizing:border-box}.vrs{padding:22px 0;border-top:1px solid rgba(var(--color-foreground,29 29 31),.13)}.vrs:first-child{border-top:0;padding-top:0}.vrh{font-size:21px;line-height:1.2;font-weight:500;margin:0 0 14px}.vrhint{font-size:14px;line-height:1.42;color:rgba(var(--color-foreground,29 29 31),.68);margin:-6px 0 14px}.vro{display:grid;gap:12px}.vro.color{grid-template-columns:repeat(2,minmax(0,1fr))}.vro.kit{grid-template-columns:1fr}.vrc{appearance:none;width:100%;text-align:left;border:1px solid #6e6e73;background:rgb(var(--color-background,255 255 255));border-radius:13px;padding:15px 18px;color:inherit;cursor:pointer;transition:border-color .16s ease,background .16s ease}.vrc[aria-pressed=true]{border-color:#f55f0c;background:linear-gradient(135deg,#fff 0%,rgba(245,95,12,.06) 100%)}.vrc.color{min-height:58px;display:flex;align-items:center}.vrc.color .t{font-size:16px;font-weight:400}.top{display:flex;align-items:flex-start;justify-content:space-between;gap:14px}.t{display:block;font-size:17px;font-weight:750;line-height:1.22}.txt{display:block;font-size:13.5px;line-height:1.4;color:rgba(var(--color-foreground,29 29 31),.72);margin-top:4px}.tag{display:inline-block;margin-top:8px;padding:4px 9px;border-radius:999px;background:rgba(245,95,12,.08);color:#d84f05;font-size:12px;font-weight:650;line-height:1}.pr{font-size:15px;font-weight:800;color:#f55f0c;white-space:nowrap}.dot{display:inline-block;width:16px;height:16px;border-radius:999px;border:1px solid rgba(var(--color-foreground,29 29 31),.18);box-shadow:inset 0 0 0 2px #fff;margin-right:10px;vertical-align:-2px}.dot.b{background:#000}.dot.s{background:#d5d5d5}.sum{display:none;margin-top:18px;padding:18px 20px;border-radius:18px;background:#f5f5f7;font-size:14px;line-height:1.42;align-items:center;justify-content:space-between;gap:14px}.sum.ready{display:flex}.sum small{display:block;margin-bottom:4px;font-size:12px;font-weight:750;color:#d84f05}.sum strong{font-weight:750}.sum .price{display:flex;flex-direction:column;align-items:flex-end;gap:2px;white-space:nowrap}.sum .was{font-size:14px;color:rgba(var(--color-foreground,29 29 31),.48);text-decoration:line-through}.sum .now{font-size:20px;font-weight:800;color:#f55f0c}.viaim-hidden-selection{display:none!important}@media(max-width:749px){.vro.color{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}.vrc{padding:15px}.vrc.color{min-height:54px;padding:13px 12px}.vrc.color .t{font-size:15px}.dot{margin-right:8px}.sum.ready{align-items:flex-start;flex-direction:column}.sum .price{align-items:flex-start}}";
  var extraCss = ".viaim-opennote-promo{margin:18px 0 18px;min-height:96px;border-radius:14px;padding:18px 20px;overflow:hidden;color:#fff;background:linear-gradient(110deg,rgba(23,23,23,.94) 0%,rgba(69,46,34,.9) 48%,rgba(245,95,12,.88) 100%);display:flex;flex-direction:column;justify-content:center;gap:4px}.viaim-opennote-promo span{font-size:12px;line-height:1.2;letter-spacing:.01em;opacity:.84}.viaim-opennote-promo strong{font-size:20px;line-height:1.15;font-weight:700}.viaim-opennote-promo em{font-size:13px;line-height:1.35;font-style:normal;opacity:.86}.viaim-feature-fold{position:relative}.viaim-feature-fold.is-collapsed .viaim-feature-preview{display:block;max-height:34px;overflow:hidden;opacity:.28;position:relative}.viaim-feature-fold.is-collapsed .viaim-feature-preview:after{content:\"\";position:absolute;inset:auto 0 0 0;height:24px;background:linear-gradient(180deg,rgba(var(--color-background,255 255 255),0),rgb(var(--color-background,255 255 255)))}.viaim-feature-fold.is-collapsed .viaim-feature-hidden{display:none}.viaim-feature-toggle{appearance:none;background:transparent;border:0;color:rgb(var(--color-foreground,29 29 31));cursor:pointer;display:flex;align-items:center;gap:8px;font:inherit;font-size:14px;line-height:1.2;margin:8px 0 0 auto;padding:8px 0;text-decoration:underline;text-underline-offset:3px}.viaim-feature-toggle:after{content:\"\";width:8px;height:8px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg);margin-top:-4px}.viaim-feature-toggle[aria-expanded=true]:after{transform:rotate(225deg);margin-top:4px}.viaim-feature-fold:not(.is-collapsed) .viaim-feature-preview{opacity:1;max-height:none}.viaim-feature-fold:not(.is-collapsed) .viaim-feature-hidden{display:block}@media(max-width:749px){.viaim-opennote-promo{min-height:82px;padding:15px 16px;border-radius:12px}.viaim-opennote-promo strong{font-size:17px}.viaim-opennote-promo em{font-size:12.5px}}";

  function stateFromVariant(id) {
    if (!id) return null;
    if (legacy[id]) return { color: legacy[id][0], noteKit: legacy[id][1], plan: legacy[id][2] };
    for (var color in data) {
      for (var kit in data[color]) {
        for (var plan in data[color][kit]) {
          if (data[color][kit][plan][0] === id) return { color: color, noteKit: kit === "noteKit", plan: plan };
        }
      }
    }
    return null;
  }
  function section() {
    var form = document.querySelector('main form[action*="/cart/add"]');
    return form && form.closest('[id^="shopify-section-"]') || document;
  }
  function kitKey() {
    return state.noteKit ? "noteKit" : "base";
  }
  function itemFor(kit, plan) {
    return data[state.color || "Black"][kit][plan || state.plan || "free"];
  }
  function variant(plan) {
    return itemFor(kitKey(), plan);
  }
  function selectedVariant() {
    return state.plan ? variant(state.plan) : null;
  }
  function forms(root) {
    return Array.prototype.slice.call(root.querySelectorAll('form[action*="/cart/add"]'));
  }
  function hasOption(node, values) {
    if (node.tagName === "SELECT") return Array.prototype.slice.call(node.options).some(function (option) { return values.indexOf(option.value) > -1; });
    return values.indexOf(node.value) > -1;
  }
  function nativeGroups(root) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll('input[type="radio"],select'));
    var groups = [];
    nodes.forEach(function (node) {
      if (!hasOption(node, colors) && !hasOption(node, selections)) return;
      var group = node.closest("fieldset") || node.closest(".product-form__input") || node.parentElement;
      if (group && groups.indexOf(group) < 0) groups.push(group);
    });
    return groups;
  }
  function hideNative(root) {
    nativeGroups(root).forEach(function (group) {
      group.classList.add(hiddenClass);
      group.setAttribute("aria-hidden", "true");
    });
  }
  function setFormVariant(root, item) {
    forms(root).forEach(function (form) {
      Array.prototype.slice.call(form.querySelectorAll('[name="id"]')).forEach(function (input) {
        input.value = item[0];
      });
    });
  }
  function setButton(root, item) {
    Array.prototype.slice.call(root.querySelectorAll('[name="add"],.product-form__submit,button[type="submit"]')).forEach(function (button) {
      button.textContent = item ? "Add to cart - $" + item[1].toFixed(2) : "Choose AI plan";
    });
  }
  function updateUrl(item) {
    if (!item || !history.replaceState) return;
    var url = new URL(location.href);
    url.searchParams.set("variant", item[0]);
    history.replaceState({}, "", url.toString());
  }
  function updateImage(root, item) {
    if (!item || !item[3]) return;
    if (isCompactView()) {
      var mediaId = item[5];
      var activeMedia = root.querySelector('media-dots [aria-current="true"]');
      if (lastGalleryVariant === item[0] && activeMedia && activeMedia.getAttribute("data-media-id") === String(mediaId)) return;
      lastGalleryVariant = item[0];
      var thumbnail = mediaId && root.querySelector('media-dots [data-media-id="' + mediaId + '"]');
      if (thumbnail) { thumbnail.click(); return; }
    }
    var media = root.querySelector(".product__media:not([hidden])") || document.querySelector(".product__media");
    var img = media && media.querySelector("img") || document.querySelector(".product__media img");
    if (!img) return;
    Array.prototype.slice.call((img.closest("picture") || media || document).querySelectorAll("source")).forEach(function (source) {
      source.removeAttribute("srcset");
      source.removeAttribute("data-srcset");
    });
    img.removeAttribute("srcset");
    img.removeAttribute("data-src");
    img.removeAttribute("data-srcset");
    img.src = item[3];
    img.removeAttribute("sizes");
    img.loading = "eager";
    img.alt = "viaim OpenNote " + state.color + " " + planName();
  }
  function money(item) {
    return "$" + item[1].toFixed(2);
  }
  function save(item) {
    var diff = Math.round((item[2] - item[1]) * 100) / 100;
    return diff > 0.99 ? "Save $" + diff.toFixed(2) : "";
  }
  function compactMoney(value) {
    var rounded = Math.round(Number(value) * 100) / 100;
    return "$" + (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2));
  }
  function updatePlanCards(el) {
    var freeItem = itemFor(kitKey(), "free");
    ["pro", "ultra"].forEach(function (plan) {
      var planItem = itemFor(kitKey(), plan);
      var price = el.querySelector('[data-plan-price="' + plan + '"]');
      var saving = el.querySelector('[data-plan-saving="' + plan + '"]');
      var diff = Math.max(0, Number(planItem[1]) - Number(freeItem[1]));
      if (price) price.textContent = "+" + compactMoney(diff) + "/year";
      if (saving) {
        var discount = Math.max(0, Math.round(((planItem[2] - planItem[1]) - (freeItem[2] - freeItem[1])) * 100) / 100);
        saving.textContent = discount > 0 ? "Save " + compactMoney(discount) : "";
      }
    });
  }
  function planName() {
    return state.plan === "pro" ? "Annual Pro" : state.plan === "ultra" ? "Annual Ultra" : state.plan === "free" ? "Free AI" : "AI plan not selected";
  }
  function bundleName() {
    return state.noteKit ? "OpenNote + NoteKit" : "OpenNote";
  }
  function findFeatureBlock(root) {
    var candidates = Array.prototype.slice.call(root.querySelectorAll(".product__info div,.product__description,.rte,[class*='description']"));
    candidates = candidates.filter(function (el) {
      var text = (el.textContent || "").replace(/\s+/g, " ");
      return text.indexOf("Open-ear AI Note Taker") > -1 && text.indexOf("Open-Ear Comfort:") > -1 && text.indexOf("600 Minutes Included:") > -1 && el.querySelectorAll("p").length > 3;
    });
    candidates.sort(function (a, b) {
      return b.querySelectorAll("p").length - a.querySelectorAll("p").length || (a.textContent || "").length - (b.textContent || "").length;
    });
    return candidates[0] || null;
  }
  function enhanceFeatures(root) {
    var block = findFeatureBlock(root);
    if (!block) return;
    Array.prototype.slice.call(root.querySelectorAll(".viaim-feature-toggle")).slice(1).forEach(function (toggle) {
      toggle.parentNode.removeChild(toggle);
    });
    if (block.classList.contains("viaim-feature-fold") && block.querySelector(".viaim-feature-toggle")) return;
    Array.prototype.slice.call(block.querySelectorAll(".viaim-feature-toggle")).forEach(function (toggle) {
      toggle.parentNode.removeChild(toggle);
    });
    var items = Array.prototype.slice.call(block.querySelectorAll("p")).filter(function (item) {
      return (item.textContent || "").trim();
    });
    if (items.length <= 3) return;
    block.classList.add("viaim-feature-fold", "is-collapsed");
    items.forEach(function (item) {
      item.classList.remove("viaim-feature-preview", "viaim-feature-hidden");
    });
    items.slice(3).forEach(function (item, index) {
      item.classList.add(index === 0 ? "viaim-feature-preview" : "viaim-feature-hidden");
    });
    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "viaim-feature-toggle";
    toggle.setAttribute("aria-expanded", "false");
    toggle.textContent = "View More";
    toggle.addEventListener("click", function () {
      var expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!expanded));
      toggle.textContent = expanded ? "View More" : "View Less";
      block.classList.toggle("is-collapsed", expanded);
    });
    block.appendChild(toggle);
  }
  function addCompactDisclosure(el, selector, items, label, expanded, key) {
    var group = el.querySelector(selector);
    if (!group) return;
    var panel = document.createElement("div");
    panel.className = "vr-fold";
    panel.id = "vr-fold-" + items[0].replace(/[^a-z]/gi, "");
    panel.hidden = !expanded;
    var first = group.querySelector(items[0]);
    if (!first) return;
    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "vr-expand";
    toggle.setAttribute("aria-controls", panel.id);
    toggle.setAttribute("aria-expanded", String(expanded));
    toggle.innerHTML = '<span>' + label + '</span><span class="vr-expand__chevron" aria-hidden="true"></span>';
    group.insertBefore(toggle, first);
    group.insertBefore(panel, first);
    items.forEach(function (item) {
      var card = group.querySelector(item);
      if (card) panel.appendChild(card);
    });
    toggle.addEventListener("click", function () {
      var open = toggle.getAttribute("aria-expanded") !== "true";
      toggle.setAttribute("aria-expanded", String(open));
      panel.hidden = !open;
      disclosureOpen[key] = open;
    });
  }
  function expandSelected(el) {
    var groups = [
      { selected: state.noteKit, card: '[data-kit="noteKit"]' },
      { selected: state.plan && state.plan !== "free", card: '[data-plan="pro"]' }
    ];
    groups.forEach(function (group) {
      if (!group.selected) return;
      var panel = el.querySelector(group.card)?.closest(".vr-fold");
      if (!panel) return;
      panel.hidden = false;
      var toggle = el.querySelector('[aria-controls="' + panel.id + '"]');
      if (toggle) toggle.setAttribute("aria-expanded", "true");
    });
  }
  function v8Markup() {
    return `<div class="vr8-color-section"><h3>Choose your color</h3><div class="vr8-color-options" role="group" aria-label="OpenNote color"><button class="vr8-color-option" type="button" data-color="Black"><span class="vr8-color-swatch black" aria-hidden="true"></span>Black</button><button class="vr8-color-option" type="button" data-color="White"><span class="vr8-color-swatch white" aria-hidden="true"></span>White</button></div></div>
      <div class="vr8-hardware-section"><h3>Add NoteKit to your setup?</h3><div class="vr8-hardware-options" role="group" aria-label="OpenNote hardware"><button class="vr8-hardware-option" type="button" data-kit="base"><span class="vr8-hardware-top"><span class="vr8-hardware-label">OpenNote only</span><span class="vr8-hardware-price" data-kit-base-price></span></span><span class="vr8-hardware-desc vr8-base-desc">Open-ear AI note taking included.</span></button><div class="vr8-kit-column"><button class="vr8-hardware-option" type="button" data-kit="noteKit"><span class="vr8-hardware-top"><span class="vr8-hardware-label">OpenNote + NoteKit</span><span class="vr8-hardware-price" data-kit-total></span></span><span class="vr8-hardware-desc">Record computer meetings directly with NoteKit.</span><span class="vr8-hardware-save" data-kit-saving></span></button><button class="vr8-note-info" type="button" data-vr8-note-toggle aria-expanded="false" aria-controls="vr8-note-panel">What's NoteKit?<span class="vr8-chevron" aria-hidden="true"></span></button></div><div class="vr8-note-panel" id="vr8-note-panel" hidden><img class="vr8-note-photo" src="https://cdn.shopify.com/s/files/1/0722/7647/6150/files/viaim-notekit-exploded-view.png?v=1792133939" alt="viaim NoteKit USB AI voice recorder" loading="lazy" width="112" height="112"><div class="vr8-note-copy"><strong>A USB AI voice recorder for your computer.</strong><p>Plug NoteKit into your computer to capture meetings directly, with up to 5 m voice pickup.</p></div></div></div></div>
      <div class="vr8-plan-section"><h3>Choose your AI plan</h3><p class="vr8-intro">600 free minutes every month. Upgrade anytime.</p><div class="vr8-plans-box"><button class="vr8-plan-row" type="button" data-plan="free"><span class="vr8-status" aria-hidden="true"></span><span class="vr8-details"><span class="vr8-name">Free plan</span><span class="vr8-sub">600 min/month included</span></span><span class="vr8-right"><span class="vr8-plan-price">Free</span></span></button><button class="vr8-plan-row" type="button" data-vr8-plans-toggle aria-expanded="false" aria-controls="vr8-annuals"><span class="vr8-sparkle" aria-hidden="true">✦</span><span class="vr8-details"><span class="vr8-name">Upgrade to an annual plan</span><span class="vr8-sub" data-vr8-plan-subtitle></span></span><span class="vr8-chevron" aria-hidden="true"></span></button><div class="vr8-annuals" id="vr8-annuals" hidden><button class="vr8-annual-option" type="button" data-plan="pro"><span class="vr8-status" aria-hidden="true"></span><span class="vr8-details"><span class="vr8-name">Annual Pro</span><span class="vr8-sub">1,800 min/month · For frequent meetings</span></span><span class="vr8-right"><span class="vr8-plan-price" data-plan-price="pro"></span><span class="vr8-plan-save" data-plan-saving="pro"></span></span></button><button class="vr8-annual-option" type="button" data-plan="ultra"><span class="vr8-status" aria-hidden="true"></span><span class="vr8-details"><span class="vr8-name">Annual Ultra</span><span class="vr8-sub">Unlimited · For daily use</span></span><span class="vr8-right"><span class="vr8-plan-price" data-plan-price="ultra"></span><span class="vr8-plan-save" data-plan-saving="ultra"></span></span></button></div></div></div>
      <div class="vr8-summary sum ready" aria-live="polite"><span class="vr8-summary-copy"><span class="vr8-summary-heading">Your selection</span><strong class="vr8-selection-name" data-summary></strong><span class="vr8-selection-saving" data-note></span></span><span class="vr8-summary-price price" data-total></span></div>`;
  }
  function paintV8(root, el, item, baseItem, kitItem) {
    var bundleDelta = Math.max(0, Math.round((kitItem[1] - baseItem[1]) * 100) / 100);
    el.querySelector("[data-kit-total]").textContent = "+" + compactMoney(bundleDelta);
    var bundleSaving = Math.max(0, Math.round(((kitItem[2] - kitItem[1]) - (baseItem[2] - baseItem[1])) * 100) / 100);
    el.querySelector("[data-kit-saving]").textContent = bundleSaving > 0 ? "Save " + compactMoney(bundleSaving) : "";
    el.querySelector("[data-vr8-plan-subtitle]").textContent = "From +" + compactMoney(itemFor(kitKey(), "pro")[1] - itemFor(kitKey(), "free")[1]) + "/year · Save on AI minutes";
    var annuals = el.querySelector("#vr8-annuals");
    var open = disclosureOpen.plans || state.plan !== "free";
    annuals.hidden = !open;
    el.querySelector("[data-vr8-plans-toggle]").setAttribute("aria-expanded", String(open));
    var titlePrice = root.querySelector(".product__price .price__regular");
    if (titlePrice && item) titlePrice.textContent = money(item);
    var add = root.querySelector(".product-form__submit");
    if (add && item) add.disabled = item[4] === false;
  }
  function render(root, before) {
    var el = document.createElement("div");
    el.className = flowClass;
    el.innerHTML = '<div class="vrs"><h3 class="vrh">Choose your color</h3><div class="vro color"><button class="vrc color" type="button" data-color="Black"><span class="t"><span class="dot b"></span>Black</span></button><button class="vrc color" type="button" data-color="White"><span class="t"><span class="dot w"></span>White</span></button></div></div><div class="vrs"><h3 class="vrh">Add NoteKit to your setup?</h3><div class="vro kit"><button class="vrc" type="button" data-kit="base"><span class="top"><span><span class="t">OpenNote only</span></span><span class="pr" data-kit-base-price>$229.00</span></span></button><button class="vrc" type="button" data-kit="noteKit"><span class="top"><span><span class="t">OpenNote + NoteKit</span><span class="txt">A USB AI meeting recorder for your computer.</span><span class="tag" data-kit-saving>Save $21.99</span></span><span class="pr" data-kit-total>$279.00</span></span></button></div></div><div class="vrs"><h3 class="vrh">Choose your AI plan</h3><p class="vrhint">600 min/month included. Add an annual plan when you need more.</p><div class="vro"><button class="vrc" type="button" data-plan="free"><span class="top"><span><span class="t">Free</span><span class="txt">600 min/mo - Occasional recording</span></span><span class="pr">Included</span></span></button><button class="vrc" type="button" data-plan="pro"><span class="top"><span><span class="t">Annual Pro</span><span class="txt">1,800 min/mo - Best for frequent meetings</span><span class="tag" data-plan-saving="pro"></span></span><span class="pr" data-plan-price="pro"></span></span></button><button class="vrc" type="button" data-plan="ultra"><span class="top"><span><span class="t">Annual Ultra</span><span class="txt">Unlimited - Best for heavy daily use</span><span class="tag" data-plan-saving="ultra"></span></span><span class="pr" data-plan-price="ultra"></span></span></button></div></div><div class="sum" aria-live="polite"><span><small>Your selection</small><strong data-summary></strong><br><span data-note></span></span><span class="price" data-total></span></div>';
    if (isCompactView()) {
      el.classList.add("vr8");
      el.innerHTML = v8Markup();
    }
    before.parentNode.insertBefore(el, before);
    el.addEventListener("click", function (event) {
      var annualToggle = event.target.closest("[data-vr8-plans-toggle]");
      if (annualToggle) { disclosureOpen.plans = annualToggle.getAttribute("aria-expanded") !== "true"; paint(); return; }
      var noteToggle = event.target.closest("[data-vr8-note-toggle]");
      if (noteToggle) { var panel = el.querySelector("#vr8-note-panel"); panel.hidden = !panel.hidden; noteToggle.setAttribute("aria-expanded", String(!panel.hidden)); return; }
      var color = event.target.closest("[data-color]");
      var kit = event.target.closest("[data-kit]");
      var plan = event.target.closest("[data-plan]");
      if (color) state.color = color.getAttribute("data-color");
      if (kit) state.noteKit = kit.getAttribute("data-kit") === "noteKit";
      if (plan) state.plan = plan.getAttribute("data-plan");
      paint();
    });
  }
  function paint(prompt) {
    var root = section();
    var el = root.querySelector("." + flowClass);
    if (!el) return init();
    hideNative(root);
    if (isCompactView() && state.plan !== "free") disclosureOpen.plans = true;
    Array.prototype.slice.call(el.querySelectorAll("[data-color]")).forEach(function (button) {
      button.setAttribute("aria-pressed", String(button.getAttribute("data-color") === state.color));
    });
    Array.prototype.slice.call(el.querySelectorAll("[data-kit]")).forEach(function (button) {
      button.setAttribute("aria-pressed", String((button.getAttribute("data-kit") === "noteKit") === state.noteKit));
    });
    Array.prototype.slice.call(el.querySelectorAll("[data-plan]")).forEach(function (button) {
      button.setAttribute("aria-pressed", String(button.getAttribute("data-plan") === state.plan));
    });
    var item = selectedVariant();
    var imageItem = item || variant("free");
    var displayPlan = state.plan || "free";
    var baseItem = itemFor("base", displayPlan);
    var kitItem = itemFor("noteKit", displayPlan);
    el.querySelector("[data-kit-base-price]").textContent = money(baseItem);
    el.querySelector("[data-kit-total]").textContent = money(kitItem);
    el.querySelector("[data-kit-saving]").textContent = save(kitItem);
    updatePlanCards(el);
    if (isCompactView()) paintV8(root, el, item, baseItem, kitItem);
    var summary = el.querySelector(".sum");
    el.querySelector("[data-summary]").textContent = bundleName() + " / " + state.color + " / " + planName();
    if (!item) {
      summary.classList.remove("ready");
      el.querySelector("[data-note]").textContent = prompt ? "Please choose an AI transcription option before adding to cart." : "Choose an AI transcription option to see your final total.";
      el.querySelector("[data-total]").textContent = "";
      setFormVariant(root, imageItem);
      setButton(root, null);
      updateImage(root, imageItem);
      updateUrl(imageItem);
      return;
    }
    summary.classList.add("ready");
    el.querySelector("[data-note]").textContent = save(item) || (isCompactView() ? "600 min/month included" : "Ready to add to cart.");
    el.querySelector("[data-total]").innerHTML = item[2] > item[1] ? '<span class="was">$' + item[2].toFixed(2) + '</span><span class="now">' + money(item) + '</span>' : '<span class="now">' + money(item) + '</span>';
    setFormVariant(root, item);
    setButton(root, item);
    updateImage(root, item);
    updateUrl(item);
  }
  function bind(root) {
    forms(root).forEach(function (form) {
      if (form.dataset.viaimBound) return;
      form.dataset.viaimBound = "1";
      form.addEventListener("submit", function (event) {
        var item = selectedVariant();
        if (!item) {
          event.preventDefault();
          event.stopImmediatePropagation();
          paint(true);
          return false;
        }
        setFormVariant(root, item);
      }, true);
    });
  }
  var compactCss = ".viaim-opennote-flow .vr-fold[hidden]{display:none!important}.viaim-opennote-flow .vr-fold:not([hidden]){display:grid;gap:12px}.viaim-opennote-flow .vr-expand{appearance:none;width:100%;display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:48px;padding:11px 17px;border:1px solid rgba(var(--color-foreground,29 29 31),.34);border-radius:13px;background:rgb(var(--color-background,255 255 255));color:rgb(var(--color-foreground,29 29 31));font:inherit;font-size:14px;font-weight:600;line-height:1.3;text-align:left;cursor:pointer;transition:border-color .16s ease,background .16s ease}.viaim-opennote-flow .vr-expand:hover,.viaim-opennote-flow .vr-expand[aria-expanded=true]{border-color:#f55f0c;background:rgba(245,95,12,.035)}.viaim-opennote-flow .vr-expand:focus-visible{outline:2px solid #f55f0c;outline-offset:3px}.viaim-opennote-flow .vr-expand__chevron{flex:none;width:9px;height:9px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg);margin:-4px 3px 0 0}.viaim-opennote-flow .vr-expand[aria-expanded=true] .vr-expand__chevron{transform:rotate(225deg);margin:4px 3px 0 0}@media(max-width:749px){.viaim-opennote-flow .vr-expand{min-height:46px;padding:11px 15px;font-size:13px}}";
  function addCss() {
    if (document.getElementById("viaim-opennote-flow-style")) return;
    var style = document.createElement("style");
    style.id = "viaim-opennote-flow-style";
    style.textContent = css + extraCss + compactCss;
    document.head.appendChild(style);
  }
  function init() {
    addCss();
    if (isCompactView() && !state.plan) state.plan = "free";
    var root = section();
    hideNative(root);
    bind(root);
    enhanceFeatures(root);
    if (!root.querySelector("." + flowClass)) {
      var groups = nativeGroups(root);
      if (!groups.length) return;
      render(root, groups[0]);
    }
    paint();
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
  var resizeTimer = 0;
  window.addEventListener("resize", function () {
    if (!isCompactView()) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var root = section();
      var item = selectedVariant();
      if (item) updateImage(root, item);
    }, 180);
  });
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var root = section();
      hideNative(root);
      bind(root);
      enhanceFeatures(root);
      if (!root.querySelector("." + flowClass)) init();
    }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
